import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { toThousandslsFilter } from "@/filters";
import { getQuoteDetailProducts, erpRquestPricenotify } from "@/services/order/inquiry";
import i18nInquiry from "../i18n-inquiry";
import i18nOrderDetail from "../../i18n-orderDetail";
export default {
  name: "inquiryDetailProduct",
  i18n: {
    messages: {
      CN: _objectSpread(_objectSpread({}, i18nInquiry.messages.CN), i18nOrderDetail.messages.CN),
      JP: _objectSpread(_objectSpread({}, i18nInquiry.messages.JP), i18nOrderDetail.messages.JP)
    }
  },
  props: {
    quoteData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      productInfo: {},
      taxTotal: 0,
      tax10: 0,
      tax8: 0,
      cashOnDeliveryAmountTotal: 0,
      productTotal: 0,
      notifyLoad: false
    };
  },
  computed: {
    columns: function columns() {
      var columns = [{
        //商品编号
        title: this.$t("orderDetailProduct.productNo"),
        dataIndex: "productNo",
        key: "productNo",
        width: 100
      }, {
        //商品名称
        title: this.$t("orderDetailProduct.productName"),
        dataIndex: "productName",
        key: "productName",
        scopedSlots: {
          customRender: "productName"
        }
      },
      // 原价
      // {
      // 	title: this.$t('orderDetailProduct.price'),
      // 	dataIndex: 'price',
      // 	key: 'price',
      // 	width: 120,
      // 	scopedSlots: { customRender: 'price' },
      // 	align: 'right'
      // },

      // 商品规格

      // 售卖方式
      {
        title: this.$t("orderDetailProduct.sellWay"),
        dataIndex: "sellWay",
        key: "sellWay",
        width: 120,
        scopedSlots: {
          customRender: "sellWay"
        },
        align: "right"
      }, {
        //售价
        title: this.$t("orderDetailProduct.salePrice"),
        dataIndex: "salePrice",
        key: "salePrice",
        width: 120,
        scopedSlots: {
          customRender: "salePrice"
        },
        align: "right"
      }, {
        //商品数量
        title: this.$t("orderDetailProduct.productNum"),
        dataIndex: "productNum",
        key: "productNum",
        scopedSlots: {
          customRender: "productNum"
        },
        width: 100,
        align: "right"
      },
      // 消费税
      {
        title: this.$t("orderDetailProduct.Tax"),
        dataIndex: "taxAmount",
        key: "taxAmount",
        scopedSlots: {
          customRender: "taxAmount"
        },
        width: 100,
        align: "right"
      },
      //获取积分
      // {
      // 	title: this.$t('orderDetailProduct.getPointNum'),
      // 	dataIndex: 'getPointNum',
      // 	key: 'getPointNum',
      // 	width: 100,
      // 	align: 'right'
      // },
      {
        //金额小计
        title: this.$t("orderDetailProduct.productSubTotal"),
        dataIndex: "productSubTotal",
        key: "productSubTotal",
        scopedSlots: {
          customRender: "productSubTotal"
        },
        width: 120,
        align: "right"
      }];
      return columns;
    }
  },
  mounted: function mounted() {
    //区分运营方式
    this.deliveryChannel = localStorage.getItem("deliveryChannel");
    this.quoteId = this.$route.query.id;
    this.loadData();
    // this.loadOrderStatusList()
  },
  methods: {
    formatMoney: function formatMoney(num) {
      return localStorage.leftCurrencySymbol + toThousandslsFilter(num) + localStorage.rightCurrencySymbol;
    },
    loadData: function loadData() {
      var _this = this;
      getQuoteDetailProducts({
        id: this.quoteId
      }).then(function (response) {
        if (response.data.code == 200) {
          _this.productInfo = response.data.data;

          // 消费税
          if (_this.productInfo.taxList) {
            _this.productInfo.taxList.forEach(function (item, index) {
              if (item.taxDiff == "10%") {
                _this.tax10 = item.taxAmount;
              }
              if (item.taxDiff == "8%") {
                _this.tax8 = item.taxAmount;
              }
            });
            _this.taxTotal = _this.tax10 + _this.tax8;
          } else {
            _this.tax10 = 0;
            _this.tax8 = 0;
            _this.taxTotal = 0;
          }

          // 代引金额总数
          // this.productInfo.transportList.forEach((item,index,arr) => {
          // 	this.cashOnDeliveryAmountTotal += item.cashOnDeliveryAmount
          // 	arr[index].productTotal = 0
          // 	item.productList.forEach(item2 => {
          // 		arr[index].productTotal += item2.productSubTotal
          // 	})
          // })
          // this.orderStatus = this.productInfo.subOrderVoList[0].orderStatus
          // if(this.productInfo.isOldOrder == 1){
          // 	this.loadOldData();
          // }
        }
      });
    },
    notifyFuc: function notifyFuc() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var self, resOrder;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              self = _this2;
              self.notifyLoad = true;
              console.log(self.quoteId);
              _context.n = 1;
              return erpRquestPricenotify(self.quoteId);
            case 1:
              resOrder = _context.v;
              if (resOrder.data.code == 200) {
                self.$message.success(self.$t('inquiryList.notifySuccess'));
              }
            case 2:
              _context.p = 2;
              _this2.notifyLoad = false;
              return _context.f(2);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0,, 2, 3]]);
      }))();
    }
  }
};